var _polygon, _line, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountCeiling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "700px",
    height: "775.3px",
    viewBox: "0 0 700 775.3",
    enableBackground: "new 0 0 700 775.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EDEDED",
    points: "697.4,773.6 1.1,775.3 1.1,0 697.4,0 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 700,
    y1: 740.2,
    x2: 1.1,
    y2: 740.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 209.9,
    y: 142.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 165.8,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 234,
    height: 342.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9668,
    strokeMiterlimit: 10,
    d: "M218.2,751c0,0-7.7,8.5-15.6,8.6 c-7.9,0.1-14.6-7.5-14.6-7.5V28.6c0,0,4.9,0,15.1,0s15.1,0,15.1,0V751z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9662,
    strokeMiterlimit: 10,
    d: "M188,752.1c-6.8-2.7-10.4,1-10.4,1 s-4.5,6.5-10.9,6.5c-8,0-13.2-7.5-13.2-7.5V28.6H188V752.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9662,
    strokeMiterlimit: 10,
    d: "M153.5,752.1c-6.8-2.7-10.4,1-10.4,1 s-4.5,6.5-10.9,6.5c-8,0-13.2-7.5-13.2-7.5V28.6h34.5V752.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9662,
    strokeMiterlimit: 10,
    d: "M119,752.1c-6.8-2.7-10.4,1-10.4,1 s-4.5,6.5-10.9,6.5c-8,0-13.2-7.5-13.2-7.5V28.6H119V752.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9668,
    strokeMiterlimit: 10,
    d: "M480.1,751c0,0,7.7,8.5,15.6,8.6 c7.9,0.1,14.6-7.5,14.6-7.5V28.6c0,0-4.9,0-15.1,0c-10.2,0-15.1,0-15.1,0V751z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9662,
    strokeMiterlimit: 10,
    d: "M510.3,752.1c6.8-2.7,10.4,1,10.4,1 s4.5,6.5,10.9,6.5c8,0,13.2-7.5,13.2-7.5V28.6h-34.5V752.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9662,
    strokeMiterlimit: 10,
    d: "M544.8,752.1c6.8-2.7,10.4,1,10.4,1 s4.5,6.5,10.9,6.5c8,0,13.2-7.5,13.2-7.5V28.6h-34.5V752.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9662,
    strokeMiterlimit: 10,
    d: "M579.3,752.1c6.8-2.7,10.4,1,10.4,1 s4.5,6.5,10.9,6.5c8,0,13.2-7.5,13.2-7.5V28.6h-34.5V752.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 11,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.9994,
    width: 557,
    height: 13
  })), /*#__PURE__*/React.createElement("rect", {
    x: 628.9,
    y: 9,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.5,
    width: 24,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.1,
    y: 9,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.5,
    width: 24,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 0,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 12,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.7,
    y: 0,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 12,
    height: 24
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountCeiling);
export default __webpack_public_path__ + "static/media/mount_ceiling.92d1458fa8d7573a053d74cda6842d7f.svg";
export { ForwardRef as ReactComponent };